import { api } from './client';

export interface ReferralOverview {
  total_clicks: number;
  pending: number;
  delivered: number;
  expired: number;
  delivery_rate: number;
}

export interface ReferralDailyStats {
  date: string;
  clicks: number;
  delivered: number;
  expired: number;
}

export interface ReferralByApp {
  source_bundle_id: string;
  target_bundle_id: string;
  clicks: number;
  delivered: number;
}

export interface ReferralByCountry {
  country: string;
  clicks: number;
  delivered: number;
}

export interface RecentClick {
  id: string;
  device_id: string;
  ad_id: string;
  source_bundle_id: string;
  target_bundle_id: string;
  offer_url: string;
  ip_country: string;
  status: string;
  created_at: string;
  delivered_at: string | null;
}

export async function getReferralOverview(days: number = 30): Promise<ReferralOverview> {
  try {
    return await api.get<ReferralOverview>(`/admin/referrals/overview?days=${days}`);
  } catch {
    return { total_clicks: 0, pending: 0, delivered: 0, expired: 0, delivery_rate: 0 };
  }
}

export async function getReferralDaily(days: number = 30): Promise<ReferralDailyStats[]> {
  try {
    return await api.get<ReferralDailyStats[]>(`/admin/referrals/daily?days=${days}`);
  } catch {
    return [];
  }
}

export async function getReferralByApp(days: number = 30): Promise<ReferralByApp[]> {
  try {
    return await api.get<ReferralByApp[]>(`/admin/referrals/by-app?days=${days}`);
  } catch {
    return [];
  }
}

export async function getReferralByCountry(days: number = 30): Promise<ReferralByCountry[]> {
  try {
    return await api.get<ReferralByCountry[]>(`/admin/referrals/by-country?days=${days}`);
  } catch {
    return [];
  }
}

export interface ReferralByAdType {
  ad_type: string;
  clicks: number;
  delivered: number;
}

export async function getReferralByAdType(days: number = 30): Promise<ReferralByAdType[]> {
  try {
    return await api.get<ReferralByAdType[]>(`/admin/referrals/by-ad-type?days=${days}`);
  } catch {
    return [];
  }
}

export interface RecentClicksResponse {
  items: RecentClick[];
  total: number;
  page: number;
  limit: number;
}

export async function getRecentClicks(page: number = 0, limit: number = 50): Promise<RecentClicksResponse> {
  try {
    return await api.get<RecentClicksResponse>(`/admin/referrals/recent?page=${page}&limit=${limit}`);
  } catch {
    return { items: [], total: 0, page: 0, limit: 50 };
  }
}

export function formatNumber(num: number): string {
  return num.toLocaleString('en-US');
}
